import axios from 'axios'
import qs from 'qs'
import loading from './loading.js'

const token = JSON.parse(localStorage.getItem('base_token_u'))
axios.defaults.timeout = 300000
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
if (token !== '' && token !== null) {
  // eslint-disable-next-line dot-notation
  axios.defaults.headers.common['Authorization'] = 'Bearer ' + token.user
}
// axios.defaults.baseURL = 'http://localhost:54349'
axios.defaults.baseURL = 'https://qsn-man-api.ayqsng.cn'
// POST传参序列化(添加请求拦截
axios.interceptors.request.use((config) => {
  loading.showLoading()
  // 在发送请求之前做某件事
  if (JSON.parse(localStorage.getItem('base_token_u')) !== '' && JSON.parse(localStorage.getItem('base_token_u')) !== null) {
    // eslint-disable-next-line dot-notation
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + JSON.parse(localStorage.getItem('base_token_u')).user
  }
  if (config.method === 'post') {
    config.data = qs.stringify(config.data)
  }
  return config
}, (error) => {
  // console.log('错误的传参')
  return Promise.reject(error)
})

// 返回状态判断(添加响应拦截器)
axios.interceptors.response.use((res) => {
  loading.closeLoading()
  // 对响应数据做些事
  if (!res.data.success) {
    return Promise.resolve(res)
  }
  return res
}, (error) => {
  loading.closeLoading()
  // console.log('网络异常')
  return Promise.reject(error)
})

// 返回一个Promise(发送post请求)
export function fetchPost (url, params) {
  return new Promise((resolve, reject) => {
    axios.post(url, params)
      .then(response => {
        resolve(response)
      }, err => {
        reject(err)
      })
      .catch((error) => {
        reject(error)
      })
  })
}
// 返回一个Promise(发送get请求)
export function fetchGet (url, param) {
  return new Promise((resolve, reject) => {
    axios.get(url, { params: param })
      .then(response => {
        resolve(response)
      }, err => {
        reject(err)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export default {
  fetchPost,
  fetchGet,
  axios
}
